import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { inject, onMounted, reactive } from "vue";
import ProductPreviewComponent from "@/components/ProductPreviewComponent.vue";
import { ProductServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup(__props) {
        const productService = inject(ProductServiceSymbol);
        const products = reactive([]);
        onMounted(() => {
            productService?.loadAllProducts().then(response => {
                products.length = 0;
                response.forEach(value => products.push(value));
            });
        });
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, {
                fluid: true,
                class: "d-flex flex-wrap justify-center ma-0 pa-0"
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products, (product) => {
                        return (_openBlock(), _createBlock(ProductPreviewComponent, {
                            key: product.id,
                            product: product
                        }, null, 8, ["product"]));
                    }), 128))
                ]),
                _: 1
            }));
        };
    }
});
